export const BANK_CREDIT_PENDING = 1;
export const BANK_CREDIT_ACCEPTED = 2;
export const BANK_CREDIT_REJECTED = 3;
export const BANK_CREDIT_WAITING = 4;
export const BANK_CREDIT_CANCELLED = 5;
export const BANK_CREDIT_REGISTERED = 6;
export const BANK_CREDIT_STATUSES = {
  [BANK_CREDIT_PENDING]: 'Ð½Ð° ÑÐ°ÑÑÐ¼Ð¾ÑÑÐµÐ½Ð¸Ð¸',
  [BANK_CREDIT_ACCEPTED]: 'Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð°',
  [BANK_CREDIT_REJECTED]: 'Ð¾ÑÐºÐ°Ð·Ð°Ð½Ð¾',
  [BANK_CREDIT_WAITING]: 'Ð¾Ð¶Ð¸Ð´Ð°ÐµÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ð¹ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
  [BANK_CREDIT_CANCELLED]: 'Ð·Ð°ÑÐ²ÐºÐ° Ð¾ÑÐ¼ÐµÐ½ÐµÐ½Ð°',
  [BANK_CREDIT_REGISTERED]: 'Ð·Ð°ÑÐµÐ³Ð¸ÑÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð°',
};
